// 書籍、評論、特輯連載頁面
import axios from 'axios'
import {API_URL} from './config.js'
import { resolve } from 'url';

export default {
  getAuthor: function (AuthorID,index) {
    return new Promise((resolve,reject) =>{
      let params = {
        AuthorID: AuthorID
      }
      axios.get(`${API_URL}/Author/${this.getParams(params, false)}`).then(response => {
        // JSON responses are automatically parsed.
        this.author[index]=response.data
        resolve(response)
      }).catch(e => {
        // console.log(e)
        // this.errors.push(e)
        if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
      })
    })
  },
  getAuthorSerials: function (AuthorID) {
    axios.get(`${API_URL}/Author/${AuthorID}/Serial`).then(response => {
      // JSON responses are automatically parsed.
      this.serials = response.data
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  },
  getAuthorCollection: function (AuthorID) {
    axios.get(`${API_URL}/Author/${AuthorID}/Collection`).then(response => {
      // JSON responses are automatically parsed.
      this.collections = response.data
    }).catch(e => {
      // console.log(e)
      // this.errors.push(e)
      if(this.adBlockIsOpen){window.location.hash="alert4"}else{alert(e.message)}
    })
  }
}



// WEBPACK FOOTER //
// ./src/author.js